module.exports = __webpack_public_path__ + "static/iso9001-8568bc2b0af94859588f3d4e6af46c8c.svg";